import { memo, useState } from 'react';

import { SettingsIcon } from '@air/design-icons';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';
import { IconButton } from '@air/primitive-icon-button';

export type SettingsButtonProps = {
  options: DropdownMenuOption[];
  container?: HTMLElement | null;
  'data-testid'?: string;
};

export const SettingsButton = memo(({ options, container, 'data-testid': dataTestId }: SettingsButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu
      align="end"
      open={isOpen}
      onOpenChange={setIsOpen}
      container={container}
      trigger={
        <IconButton
          adsIcon
          icon={SettingsIcon}
          label="Settings"
          appearance="ghost"
          color="gray"
          size="medium"
          data-testid={dataTestId}
        />
      }
    >
      {renderDropdownItems({ options })}
    </DropdownMenu>
  );
});

SettingsButton.displayName = 'SettingsButton';
